import { ActionType, createAction } from "typesafe-actions";

import { Company, Person } from "@mapmycustomers/shared/types/entity";

export const fetchSelectionEntities = createAction("@dashboard/fetchSelectionEntities")<{
  accountIds: Company["id"][];
  callback: (entities: (Company | Person)[]) => void;
  contactIds: Person["id"][];
  failureCallback?: () => void;
}>();

export type SelectionEntitiesActions = ActionType<typeof fetchSelectionEntities>;
